import PropTypes from 'prop-types'
import { Select } from '../index.js'
import Validation from '../../wizard/Validation.jsx'

const SelectWiz = (props) => {
    const dataFieldText =
        props.keyName.substring(props.keyName.lastIndexOf('.') + 1) ||
        props.keyName
    const labelFieldText = props.keyName
        .split('.')
        .map((t) => parseInt(t) || t)
        .filter((i) => isNaN(i))
        .join('.')
    const validationFieldText = props.keyName
        .split('.')
        .map((t, i) =>
            i === 0 && props.idx !== undefined ? `${t}.${props.idx}` : t
        )
        .join('.')

    const form = props.name ? props.wiz?.form?.[props.name] : props.wiz?.form
    const value = props.value
        ? props.value
        : props.row
        ? props.row?.[dataFieldText]
        : form?.[dataFieldText]
    const setter = props.setRow ? props.setRow : props.wiz?.setValue

    if (props.hide) return null

    return (
        <Validation wiz={props.wiz} field={validationFieldText}>
            <Select
                label={props.label || props.wiz.getLabel(labelFieldText)}
                tooltipText={props.wiz.getToolTip(
                    props.keyName || labelFieldText || dataFieldText
                )}
                onChange={(e) => setter(dataFieldText, e.target.value)}
                options={props.options}
                name={props.name || dataFieldText}
                value={value || ''}
                disabled={props.disabled}
                title={props.title || props.wiz.getLabel(labelFieldText)}
                noEmpty={props.noEmpty}
                readOnly={props.readOnly}
                noLabel={props.noLabel}
                keyName={props.keyName}
                wiz={props.wiz}
                className={props.className}
                showId={props.showId}
            />
        </Validation>
    )
}

SelectWiz.propTypes = {
    wiz: PropTypes.any.isRequired,
    keyName: PropTypes.string.isRequired,
    name: PropTypes.string,
    endpoint: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
    showId: PropTypes.bool,
    className: PropTypes.string,
    noEmpty: PropTypes.bool,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    hideLabel: PropTypes.bool,
    noLabel: PropTypes.bool,
    label: PropTypes.string,
    value: PropTypes.any,
    row: PropTypes.any,
    setRow: PropTypes.func,
    hide: PropTypes.bool,
    idx: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default SelectWiz
